
import { cn } from '@/lib/utils';
import { AuctionState } from '@prisma/client';
import { Flex } from '@radix-ui/themes';
import React from 'react';
import { statusLookup } from '../AuctionStatusData';

interface AuctionStatusBadgeProps {
    state?: AuctionState;
    className?: string;
    variant?: 'default' | 'outline';
}

const AuctionStatusBadge = (
    { state, className, variant = 'default' }:
    AuctionStatusBadgeProps
) => {
    if (!state) return null;

    return (
        <Flex
            align="center"
            className={cn(
                "p-0.5 px-2 rounded-lg",
                variant === 'outline' ? "text-black" : statusLookup[state].styling,
                className
            )}
        >
            {variant === 'outline' && (
                <span
                    className={cn(
                        "w-2 h-2 rounded-full mr-2",
                        statusLookup[state].accent
                    )}
                />
            )}
            {statusLookup[state].label}
        </Flex>
    );
};

export default AuctionStatusBadge;